var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.field},[_c('label',{class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))]),_vm._t("default"),_c('span',{class:_vm.$style.message},[_vm._v(_vm._s(_vm.message))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }